import { NB } from '@cerebral-inc/ui';
import { segmentIntegrations } from '../shared/analytics/segment';
import { ADHD_ASSESSMENT_RESULT_GET_STARTED_BUTTON } from '../shared/analytics/segment-events';

const { Flex, Text, Center, Button, useMediaQuery } = NB;

interface TextButtonBottomProps {
  title: string;
  description: string;
}

const TextButtonBottom = ({ title, description }: TextButtonBottomProps) => {
  const [isMobile] = useMediaQuery({ minWidth: 0, maxWidth: 1264 });

  const handleContinue = () => {
    window.analytics?.track(
      ADHD_ASSESSMENT_RESULT_GET_STARTED_BUTTON,
      { title },
      segmentIntegrations
    );
    window.open(`${process.env.REACT_APP_CLIENT_APP_URL}`, '_self');
  };

  return (
    <Center py={{ base: '64px', sm: '96px' }} mx={isMobile ? '24px' : 0}>
      <div
        style={{
          background: 'linear-gradient(135deg, #EEECF5 0%, #C3CFFC 100%)',
          borderRadius: '16px',
          width: isMobile ? '100%' : '1216px'
        }}
      >
        <Flex
          px={{ base: '24px', sm: '64px' }}
          py={{ base: '40px', sm: '64px' }}
          justifyContent="center"
          alignItems="center"
        >
          <Text
            textAlign="center"
            color="#1C1E21"
            fontSize={{ base: '24px', sm: '28px' }}
            fontWeight={600}
            lineHeight={{ base: '28px', sm: '32px' }}
            maxW="768px"
            fontFamily="Poppins"
          >
            {title}
          </Text>
          <Text
            textAlign="center"
            color="#353A41"
            fontSize="16px"
            lineHeight="24px"
            mt="20px"
            maxW="768px"
            fontFamily="Poppins"
          >
            {description}
          </Text>
          <Button
            w={{ base: '100%', sm: '320px' }}
            mt="32px"
            h="56px"
            _text={{ fontSize: '14px', fontWeight: 600, fontFamily: 'Poppins' }}
            onPress={handleContinue}
          >
            Continue
          </Button>
        </Flex>
      </div>
    </Center>
  );
};

export default TextButtonBottom;
